import { BranchesOutlined, CloseOutlined, PlusOutlined, SearchOutlined, RobotOutlined } from '@ant-design/icons';
import { Flex, Typography, Button, message, Input, Modal } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AddEditFormCondition from './AddEditConditionForm';
import { showLoader } from '../../../utils/showloader';
import { deleteFormCondition, getSpaceWorkflow, saveFormCOndition } from '../../../services/WorkflowServices';
import ConditionRow from './ConditionRow';
import { useParams } from 'react-router-dom';


const ConditionManager = ({ workflowSteps, formId, formElements, conditions=[], fetchConditions, onGenerateConditions }) => {
    const { t } = useTranslation();
    const [formConditions, setFormConditions] = useState([])
    const [showForm, setShowForm] = useState(false)
    const [selectedCondition, setSelectedCondition] = useState({})
    const [showSearch, setShowSearch] = useState(false)
    const [searchTerm, setSearchTerm] = useState("")
    const [filteredConditions, setFilteredConditions] = useState([])
    const [promptOpen, setPromptOpen] = useState(false)
    const [promptText, setPromptText] = useState("")
    const [isGenerating, setIsGenerating] = useState(false)
    const { spaceId } = useParams()

    useEffect(() => {
        setFormConditions(conditions)
    }, [conditions])

    // Filter conditions based on search term
    useEffect(() => {
        if (searchTerm.trim() === "") {
            setFilteredConditions(formConditions)
        } else {
            const filtered = formConditions.filter(condition =>
                condition.name?.toLowerCase().includes(searchTerm.toLowerCase())
            )
            setFilteredConditions(filtered)
        }
    }, [searchTerm, formConditions])



    const closeStepDetails = () => {
        let containerEle = document.getElementById("condition-container");
        if (containerEle) {
            containerEle.style.display = "none";
        }
    }

    const saveConditions = async (updatedCondition) => {
        let postData = { ...updatedCondition }
        if (formId !== "new") {
            postData.formId = formId;
        }
        // let updatedCOnditions = [...formConditions]
        // if(updatedCondition.conditionId) {
        //     updatedCOnditions = formConditions.map(condition => {
        //     if(condition.conditionId === updatedCondition.conditionId){
        //         return updatedCondition
        //     }
        //     return condition
        // })
        // } else {
        //     updatedCOnditions.push(updatedCondition)
        // }
        // setFormConditions([...updatedCOnditions])
        // return
        showLoader(true)
        let saveResponse = await saveFormCOndition(postData)
        showLoader(false)
        if (saveResponse.status !== 200) {
            message.error(saveResponse.message)
            return
        }
        message.success(t('Condition saved successfully'));
        fetchConditions();
        setShowForm(false)
    }

    const handleAddNew = (condition = {}) => {
        setSelectedCondition(condition)
        setShowForm(true)
    }

    const handleConditionClick = (condition) => {
        setSelectedCondition({ ...condition })
        setShowForm(true)
    }

    const handleCancel = () => {
        setShowForm(false)
        setSelectedCondition({})
    }

    const handleConditionDelete = async (conditionId) => {
        showLoader(true)
        let deleteResponse = await deleteFormCondition(conditionId)
        showLoader(false)
        if (deleteResponse.status !== 200) {
            message.error(deleteResponse.message)
            return
        }
        message.success(deleteResponse.message)
        fetchConditions();
    }

    const handleConditionCopy = (condition) => {
        let updatedCondition = { ...condition, name: condition.name + " copy" }
        delete updatedCondition.conditionId
        saveConditions(updatedCondition)
    }

    const handleSearchToggle = () => {
        setShowSearch(!showSearch)
        if (showSearch) {
            setSearchTerm("")
        }
    }

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value)
    }

    const handlePromptSubmit = async () => {
        const trimmedPrompt = (promptText || "").trim()
        if (!trimmedPrompt) {
            message.error(t('Please enter a prompt.'))
            return
        }
        if (!onGenerateConditions) {
            message.error(t('Condition generator is not available.'))
            return
        }
        setIsGenerating(true)
        const result = await onGenerateConditions(trimmedPrompt)
        setIsGenerating(false)
        if (result?.ok) {
            setPromptText("")
            setPromptOpen(false)
            fetchConditions?.()
        }
    }

    return (
        <div className='condition-manager-container' id="condition-container" >
            {
                !showForm ?
                    <>
                        <Flex align="center" justify="space-between" className='condition-header'>
                            <Typography.Title level={5} className='margin-0'>{t('Conditional Logic form')}</Typography.Title>
                            <CloseOutlined className="icon-medium" onClick={closeStepDetails} />
                        </Flex>
                        <div className='px-4 mx-2 my-4'>
                            <div className='flex justify-between items-center'>
                                <Flex gap={8}>
                                    {
                                        conditions.length > 0 ?
                                            <Button className='bordered-button' icon={<PlusOutlined />} onClick={() => handleAddNew({})}>{t('Add new condition')}</Button>
                                            : null
                                    }
                                    {/* <Button className='bordered-button' icon={<RobotOutlined />} onClick={() => setPromptOpen(true)}>Generate From Prompt</Button> */}
                                </Flex>
                                {
                                    conditions.length > 0 && <Input className='mx-2' style={{ width: "40%" }}
                                        placeholder={t('Search conditions...')}
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                        prefix={<SearchOutlined className='mx-0' />}
                                        allowClear
                                    />
                                }
                            </div>
                            {
                                filteredConditions.length === 0 && formConditions.length === 0 ?
                                    <div className='add-condition-container' onClick={() => handleAddNew({})} style={{ marginTop: "8px" }}>
                                        <Flex className='add-condition-node' justify='center' align='center'>
                                            <BranchesOutlined />
                                        </Flex>
                                        <div className="node-title text-weight-400">{t('Add new condition')}</div>
                                    </div>
                                    :
                                    <>
                                        <div className='flex justify-between items-center'>
                                            {/* {
                                                showSearch && <Flex className='justify-between'>
                                                    <CloseOutlined className="icon-medium mx-2" onClick={handleSearchToggle} style={{ cursor: 'pointer', width: "16px" }} />

                                                </Flex>
                                            } */}
                                            {/* {
                                                !showSearch && 
                                            <SearchOutlined className="icon-medium" onClick={handleSearchToggle} style={{ cursor: 'pointer', width: "16px" }} />
                                            } */}
                                        </div>
                                    </>
                            }
                        </div>
                        <div className='condition-details-body'>
                            {
                                filteredConditions.map(condition => {
                                    return <ConditionRow key={"condition-" + condition.conditionId} condition={condition} handleConditionClick={handleConditionClick} handleConditionDelete={handleConditionDelete} handleConditionCopy={handleConditionCopy} />
                                })
                            }
                        </div>
                    </>
                    : <AddEditFormCondition selectedCondition={selectedCondition} setShowForm={setShowForm} formElements={formElements} saveConditions={saveConditions} handleCancel={handleCancel} workflowSteps={workflowSteps} />
            }

            <Modal
                title={t('Generate Conditions')}
                open={promptOpen}
                onCancel={() => setPromptOpen(false)}
                footer={null}
                destroyOnHidden
            >
                <Input.TextArea
                    rows={6}
                    placeholder={t('Describe the conditions you want to create...')}
                    value={promptText}
                    onChange={(e) => setPromptText(e.target.value)}
                />
                <Flex justify="flex-end" gap={8} style={{ marginTop: "12px" }}>
                    <Button onClick={() => setPromptOpen(false)} disabled={isGenerating}>
                        {t('Cancel')}
                    </Button>
                    <Button type="primary" onClick={handlePromptSubmit} loading={isGenerating}>
                        {isGenerating ? t('Generating...') : t('Generate')}
                    </Button>
                </Flex>
            </Modal>
        </div >
    )
}

export default ConditionManager
